import { render, staticRenderFns } from "./Freight.vue?vue&type=template&id=30d70e32&lang=html&"
import script from "./Freight.vue?vue&type=script&lang=js&"
export * from "./Freight.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports